import { makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";
import { useDataTableStyles } from "@/components/data-table";
import { DocLinkChip, DocLinkMark, DocLinkMore, DocVisibilityChoices } from "./DocLinkChip";
import type { DocumentChip } from "./doc-links";
import { visibilityCopy } from "./doc-visibility";

const live: DocumentChip = {
  linkId: "sample-live",
  targetKind: "executionTask",
  targetId: "x1",
  title: "화면 문구를 고친다",
  status: "진행 중",
  missing: false,
  executionStatus: "inProgress",
};

const missing: DocumentChip = {
  linkId: "sample-missing",
  targetKind: "scheduleTask",
  targetId: "t1",
  code: "1.2",
  title: "요구사항 정리",
  status: "삭제됨",
  missing: true,
};

const superseded: DocumentChip = {
  linkId: "sample-super",
  targetKind: "record",
  targetId: "r1",
  code: "DEC-2",
  title: "로그인 방식",
  status: "대체됨",
  missing: false,
  recordKind: "decision",
  recordStatus: "superseded",
  supersede: "DEC-4로 대체됨",
};

const useStyles = makeStyles({
  stack: { display: "flex", flexDirection: "column", gap: tokens.spacingVerticalM },
  chips: { display: "flex", flexDirection: "column", gap: "4px", maxWidth: "420px" },
  title: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "280px",
  },
  num: { textAlign: "right", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" },
});

/** 디자인 시스템 기초에 두는 목록 행, 칩 셋, 구분. 에디터는 넣지 않는다. */
export function DocDesignSamples() {
  const styles = useStyles();
  const table = useDataTableStyles();
  const [visibility, setVisibility] = useState<"private" | "plan">("private");
  const copy = visibilityCopy(visibility, "local");
  return (
    <div className={styles.stack}>
      <div className={table.frame}>
        <table className={table.table} aria-label="문서 목록 예시">
          <thead>
            <tr>
              <th className={table.th}>번호</th>
              <th className={table.th}>제목</th>
              <th className={table.th}>종류</th>
              <th className={table.th}>연결</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={table.td}>
                <span className={styles.num}>DOC-12</span>
              </td>
              <td className={table.td}>
                <span className={styles.title} title="주간 회의에서 정한 화면 문구와 남은 이슈">
                  주간 회의에서 정한 화면 문구와 남은 이슈
                </span>
              </td>
              <td className={table.td}>회의록</td>
              <td className={table.td}>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                  <DocLinkMark chip={live} onOpen={() => {}} />
                  <DocLinkMark chip={missing} />
                  <DocLinkMore count={1} titles="DEC-2 로그인 방식" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.chips}>
        <DocLinkChip chip={live} />
        <DocLinkChip chip={missing} />
        <DocLinkChip chip={superseded} />
      </div>
      <DocVisibilityChoices
        value={visibility}
        privateBody={visibilityCopy("private", "local").body}
        planBody={visibilityCopy("plan", "local").body}
        localNote={copy.localNote}
        onPrivate={() => setVisibility("private")}
        onPlan={() => setVisibility("plan")}
      />
    </div>
  );
}
